module.exports = __webpack_public_path__ + "img/img_oms_ skill_brand@3x.83bb05ad.png";